import { render, staticRenderFns } from "./AboutActions.vue?vue&type=template&id=0d846b88&scoped=true"
import script from "./AboutActions.js?vue&type=script&lang=js&external"
export * from "./AboutActions.js?vue&type=script&lang=js&external"
import style0 from "./AboutActions.scss?vue&type=style&index=0&id=0d846b88&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d846b88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
